import React from "react"
import { VStack, Image } from "@chakra-ui/react"
import Logo from "../images/horizontal-light.svg"

export default function GradientBox({ children, showLogo = true, ...rest }) {
  return (
    <VStack
      h="100%"
      px={{ base: 8, md: 16 }}
      py={{ base: 8, md: 10 }}
      justifyContent="flex-start"
      bgGradient="linear(to-b, #3f268f, #860ebf)"
      alignItems="flex-start"
      gap={16}
      sx={{
        a: {
          color: "white",
        },
        "a:hover": {
          color: "whiteAlpha.900",
        },
      }}
      {...rest}
    >
      {showLogo ? (
        <Image width="60%" src={Logo} alt="Blind Insight Logo" />
      ) : null}
      {children}
    </VStack>
  )
}
